import {
  legacy_createStore as createStore,
  applyMiddleware,
  compose,
} from 'redux';
import createSagaMiddleware from 'redux-saga';
import { persistStore, persistReducer, createMigrate } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import rootReducer from './reducers';
import rootSaga from './rootSaga';

const migrations = {
  1: (state) => state,
  2: (state) => ({
    ...state,
    AUTH: {
      ...state.AUTH,
      allProfilesRoles: state.AUTH?.allProfilesRoles ?? [],
    },
  }),
};

const persistConfig = {
  key: 'root',
  storage,
  version: 2,
  migrate: createMigrate(migrations, { debug: false }),
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const sagaMiddleware = createSagaMiddleware();
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
  persistedReducer,
  composeEnhancers(applyMiddleware(sagaMiddleware)),
);
const persistor = persistStore(store, { manualPersist: false });
sagaMiddleware.run(rootSaga);

export { store, persistor };
